/**
 * Return URL after login: save and restore the path the user was on before
 * being redirected to login (e.g. after inactivity or 401). Single responsibility.
 */

const STORAGE_KEY = 'returnUrlAfterLogin';

const LOGIN_PATH = '/login';

/** Allowed path prefixes for return URL (app routes only). */
const ALLOWED_PREFIXES = ['/', '/projects', '/viewer', '/intekenen', '/admin/projects', '/admin/kpi'];

function isAllowedPath(pathname) {
  if (!pathname || typeof pathname !== 'string') return false;
  const p = pathname.trim();
  if (p === LOGIN_PATH) return false;
  return ALLOWED_PREFIXES.some((prefix) => p === prefix || p.startsWith(prefix + '/') || p.startsWith(prefix + '?'));
}

/**
 * Save the current URL (pathname + search) so the user can be sent back after login.
 * Call before redirecting to login (e.g. on 401 or inactivity logout).
 */
export function saveReturnUrlAfterLogin() {
  try {
    const pathname = window.location.pathname || '';
    const search = window.location.search || '';
    const full = pathname + search;
    if (!isAllowedPath(pathname)) return;
    sessionStorage.setItem(STORAGE_KEY, full);
  } catch (e) {
    // sessionStorage may be unavailable
  }
}

/**
 * Get the saved return URL and remove it. Call after successful login.
 * @returns {string|null} The saved pathname+search or null.
 */
export function getAndClearReturnUrl() {
  try {
    const url = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    return url;
  } catch (e) {
    return null;
  }
}

/**
 * Return the URL if it is a valid app return destination; otherwise null.
 * @param {string|null} url - pathname + search (no origin).
 * @returns {string|null} url if valid, else null.
 */
export function getValidReturnUrlOrDefault(url) {
  if (!url || typeof url !== 'string') return null;
  const pathname = url.split('?')[0] || url;
  return isAllowedPath(pathname) ? url : null;
}
